import styled, {css} from "styled-components";

const ActionsButton = styled.button<{isDelete: boolean}>`
  display: flex;
  width: 12px;
  padding: 15px;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  touch-action: none;
  cursor: var(--cursor, pointer);
  border-radius: 5px;
  border: none;
  outline: none;
  appearance: none;
  background-color: transparent;
  -webkit-tap-highlight-color: transparent;

  svg{
    width: 12;
    fill: #919eab;
    flex: 0 0 auto;
    margin: auto;
    height: 100%;
    overflow: visible;
    margin: 0;
    padding: 0;
    path{
      stroke: #919eab;
      stroke-width: 3;
    }
  }

  &:hover{
    background-color: rgba(0, 0, 0, 0.05);
    ${(props) => props.isDelete  ? css`
      svg{
        fill: var(--red)
      }
    `: ""}  
  }

`;

export default  ActionsButton;
